import { render, staticRenderFns } from "./Mswiper.vue?vue&type=template&id=42e7fbf5&"
import script from "./Mswiper.vue?vue&type=script&lang=js&"
export * from "./Mswiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports